module.exports = __webpack_public_path__ + "img/delete-circle.0a8db0f9.svg";